/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Getschristmascardrecord2Inputs */

const de__field_getschristmascardrecord2 = /** @type {(inputs: _Field_Getschristmascardrecord2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weihnachtskartenversand`)
};

/**

* @param {_Field_Getschristmascardrecord2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_getschristmascardrecord2 = /** @type {((inputs?: _Field_Getschristmascardrecord2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Getschristmascardrecord2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_getschristmascardrecord2(inputs)
});
export { _field_getschristmascardrecord2 as "_field_getsChristmascardRecord" }